import React, { useEffect, useState } from "react";
import api from "../../util/panelApi";
import { PageHead, Chip, when, img } from "./kit";
import { ROLE_LABEL } from "../../Components/navbar/Sidebar";

const ROLES = ["manager", "agency_rep", "moderator", "finance"];
const empty = { name: "", email: "", password: "", role: "manager", region: "", rank: "super", quotas: [], isActive: true };

// Super Admin rutbesi -> aylik gecerli ajans hedefi (AYVO ajans politikasi)
const RANKS = [
  ["bd", "BD · 3 ajans"],
  ["admin", "Admin · 6 ajans"],
  ["super", "Super Admin · 10 ajans"],
  ["ssuper", "SSuper Admin · 15 ajans"],
  ["sss20", "SSSuper Admin · 20 ajans"],
  ["sss40", "SSSuper Admin · 40 ajans"],
  ["sss60", "SSSuper Admin · 60 ajans"],
];
const RANK_LABEL = Object.fromEntries(RANKS.map(([k, v]) => [k, v.split(" · ")[0]]));
const emptyPkg = { name: "", icon: "🎁", note: "", items: [], vipLevel: 0, vipDays: 0, isActive: true };


// Uygulama ici yonetim rutbelerinin yetkileri: ac / kapa
const PERM_ROWS = [
  ["panel", "Yönetim paneli (uygulamada)"],
  ["createAgency", "Ajans açma"],
  ["ban", "Engelleme (Manager: bölgesindeki herkes · diğerleri: kendi ajansları)"],
];
const RANK_COLS = [
  ["manager", "Manager"],
  ["superadmin", "Super Admin"],
  ["sa_assistant", "SA Asistanı"],
  ["admin", "Admin"],
];
// Uygulama ici rutbe: kullanici ID'si ile ver / al
const RANK_NAME = { manager: "Manager", superadmin: "Super Admin", sa_assistant: "SA Asistanı", admin: "Admin" };
const StaffRankGive = React.memo(() => {
  const [list, setList] = useState([]);
  const [code, setCode] = useState("");
  const [rank, setRank] = useState("superadmin");
  const [msg, setMsg] = useState("");
  const load = () => api.staffRanks().then((r) => r?.status && setList(r.list || []));
  useEffect(() => {
    load();
  }, []);
  const give = async (c, rk) => {
    const r = await api.setStaffRank({ code: c, staffRank: rk });
    setMsg(r?.message || (r?.status ? "Tamam" : "Olmadı"));
    if (r?.status) {
      setCode("");
      load();
    }
  };
  return (
    <div className="card" style={{ marginBottom: 16 }}>
      <div className="card-body">
        <h6 style={{ fontWeight: 800 }}>Uygulamada rütbe ver</h6>
        <div style={{ fontSize: 12, color: "#6B7280", marginBottom: 10 }}>
          Kullanıcının ID'sini yaz, rütbesini seç. Uygulamada rozeti, çerçevesi ve "Yönetim Paneli" açılır; admin paneline giremez.
        </div>
        <div className="d-flex" style={{ gap: 8, flexWrap: "wrap", marginBottom: 12 }}>
          <input className="form-control" style={{ maxWidth: 180 }} placeholder="Kullanıcı ID" value={code} onChange={(e) => setCode(e.target.value)} />
          <select className="form-control" style={{ maxWidth: 200 }} value={rank} onChange={(e) => setRank(e.target.value)}>
            {Object.entries(RANK_NAME).map(([k, v]) => <option key={k} value={k}>{v}</option>)}
          </select>
          <button className="btn btn-primary" disabled={!code.trim()} onClick={() => give(code.trim(), rank)}>Rütbe ver</button>
          {msg && <span style={{ alignSelf: "center", fontSize: 13, color: "#16A34A" }}>{msg}</span>}
        </div>
        <table className="table table-sm" style={{ maxWidth: 820 }}>
          <thead><tr><th>Kişi</th><th>ID</th><th>Rütbe</th><th>Sorumlu Manager</th><th /></tr></thead>
          <tbody>
            {list.map((u) => (
              <tr key={u._id}>
                <td>{u.name}</td>
                <td>{u.uniqueID}</td>
                <td>{RANK_NAME[u.staffRank]}</td>
                <td>
                  {["superadmin", "admin", "sa_assistant"].includes(u.staffRank) ? (
                    <select className="form-control form-control-sm" style={{ minWidth: 150 }} value={u.staffManagerId || ""} onChange={async (e) => {
                      const r = await api.setStaffManager({ userId: u._id, managerId: e.target.value });
                      setMsg(r?.message || "");
                      load();
                    }}>
                      <option value="">— Atanmamış —</option>
                      {list.filter((m) => m.staffRank === "manager").map((m) => <option key={m._id} value={m._id}>{m.name} ({m.uniqueID})</option>)}
                    </select>
                  ) : null}
                </td>
                <td style={{ textAlign: "right" }}>
                  <button className="btn btn-sm btn-outline-danger" onClick={() => window.confirm(`${u.name} rütbesi kaldırılsın mı?`) && give(u.uniqueID || u._id, "")}>Kaldır</button>
                </td>
              </tr>
            ))}
            {!list.length && <tr><td colSpan={5} style={{ color: "#9CA3AF" }}>Henüz rütbe verilmiş kimse yok</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
});

// odaya gorunmeden giren yonetim hesaplari (AYVO ID listesi)
const GizliGiris = React.memo(() => {
  const [ids, setIds] = useState([]);
  const [yeni, setYeni] = useState("");
  const [msg, setMsg] = useState("");
  useEffect(() => {
    api.config().then((r) => r?.status && setIds((r.config?.roomGhostIds || []).map(String)));
  }, []);
  const kaydet = async (liste) => {
    const r = await api.saveConfig({ roomGhostIds: liste });
    if (r?.status) setIds(liste);
    setMsg(r?.status ? "Kaydedildi. Odaya yeniden girince geçerli olur." : r?.message || "Kaydedilemedi");
  };
  const ekle = () => {
    const c = yeni.trim();
    if (!c || ids.includes(c)) return;
    setYeni("");
    kaydet([...ids, c]);
  };
  return (
    <div className="card" style={{ marginBottom: 12 }}>
      <div className="card-body" style={{ padding: 14 }}>
        <b>Odaya gizli giriş</b>
        <div style={{ fontSize: 12.5, color: "#64748B", margin: "4px 0 10px" }}>
          Bu hesaplar odaya girince duyuru ve giriş efekti çıkmaz, listede ve kişi sayısında görünmez. Koltuğa oturursa veya mesaj yazarsa görünür.
        </div>
        <div className="d-flex" style={{ gap: 8, flexWrap: "wrap", alignItems: "center" }}>
          <input className="form-control form-control-sm" style={{ maxWidth: 180 }} placeholder="AYVO ID" value={yeni} onChange={(e) => setYeni(e.target.value)} />
          <button className="btn btn-sm btn-primary" onClick={ekle}>Ekle</button>
          {ids.map((i) => (
            <button key={i} className="btn btn-sm btn-outline-danger" title="Listeden çıkar" onClick={() => kaydet(ids.filter((x) => x !== i))}>
              {i} ✕
            </button>
          ))}
          {msg && <span style={{ fontSize: 13, color: "#64748B" }}>{msg}</span>}
        </div>
      </div>
    </div>
  );
});

const StaffPerms = React.memo(() => {
  const [perms, setPerms] = useState(null);
  const [msg, setMsg] = useState("");
  useEffect(() => {
    api.config().then((r) => r?.status && setPerms(r.config?.staffPerms || {}));
  }, []);
  const toggle = async (rank, key) => {
    const next = { ...perms, [rank]: { ...(perms[rank] || {}), [key]: !(perms[rank]?.[key] !== false) } };
    setPerms(next);
    const r = await api.saveConfig({ staffPerms: next });
    setMsg(r?.status ? "Kaydedildi" : r?.message || "Kaydedilemedi");
  };
  if (!perms) return null;
  return (
    <div className="card" style={{ marginBottom: 16 }}>
      <div className="card-body">
        <h6 style={{ fontWeight: 800 }}>Uygulama yönetim rütbeleri · yetkiler</h6>
        <div style={{ fontSize: 12, color: "#6B7280", marginBottom: 10 }}>
          Rütbe, kullanıcı profilinden verilir (Yönetim rütbesi). Burada her rütbenin uygulamada neler yapabileceğini açıp kapatırsın.
        </div>
        <table className="table table-sm" style={{ maxWidth: 620 }}>
          <thead>
            <tr>
              <th>Yetki</th>
              {RANK_COLS.map(([k, l]) => <th key={k} style={{ textAlign: "center" }}>{l}</th>)}
            </tr>
          </thead>
          <tbody>
            {PERM_ROWS.map(([pk, pl]) => (
              <tr key={pk}>
                <td>{pl}</td>
                {RANK_COLS.map(([rk]) => {
                  const on = perms[rk]?.[pk] !== false;
                  return (
                    <td key={rk} style={{ textAlign: "center" }}>
                      <button
                        className={`btn btn-sm ${on ? "btn-success" : "btn-outline-secondary"}`}
                        style={{ minWidth: 70 }}
                        onClick={() => toggle(rk, pk)}
                      >
                        {on ? "Açık" : "Kapalı"}
                      </button>
                    </td>
                  );
                })}
              </tr>
            ))}
          </tbody>
        </table>
        {msg && <div style={{ fontSize: 12, color: "#16A34A" }}>{msg}</div>}
      </div>
    </div>
  );
});

const Tab = ({ k, tab, setTab, children }) => (
  <button className={`btn btn-sm ${tab === k ? "btn-primary" : "btn-outline-secondary"}`} onClick={() => setTab(k)}>
    {children}
  </button>
);

const Staff = () => {
  const [tab, setTab] = useState("packages");
  const [pk, setPk] = useState({ packages: [], storeItems: [] });
  const [members, setMembers] = useState([]);
  const [grants, setGrants] = useState([]);
  const [edit, setEdit] = useState(null); // personel formu
  const [pkg, setPkg] = useState(null); // paket formu
  const [msg, setMsg] = useState("");

  const load = async () => {
    const [a, b, c] = await Promise.all([api.staffPackages(), api.staffMembers(), api.staffSent()]);
    if (a?.status) setPk(a);
    if (b?.status) setMembers(b.members);
    if (c?.status) setGrants(c.grants);
  };
  useEffect(() => {
    load();
  }, []);

  const saveMember = async () => {
    const r = await api.staffSaveMember(edit._id, edit);
    setMsg(r?.status ? "Kaydedildi" : r?.message || "Kaydedilemedi");
    if (r?.status) {
      setEdit(null);
      load();
    }
  };
  const savePkg = async () => {
    const r = await api.staffSavePackage(pkg._id, pkg);
    setMsg(r?.status ? "Paket kaydedildi" : r?.message || "Kaydedilemedi");
    if (r?.status) {
      setPkg(null);
      load();
    }
  };

  return (
    <>
      <PageHead
        title="Personel & Paketler"
        sub="Personel kendi rolünün sayfalarını görür. Super Admin ve ajans sorumlusu, aylık kotası kadar hazır paket gönderebilir. Coin personel üzerinden verilemez."
        right={
          <div className="d-flex" style={{ gap: 8 }}>
            {msg && <span style={{ fontSize: 13, color: "#64748B", alignSelf: "center" }}>{msg}</span>}
            {tab === "packages" && <button className="btn btn-primary" onClick={() => setPkg({ ...emptyPkg })}>+ Paket</button>}
            {tab === "members" && <button className="btn btn-primary" onClick={() => setEdit({ ...empty })}>+ Personel</button>}
          </div>
        }
      />
      <GizliGiris />
      <StaffRankGive />
      <StaffPerms />
      <div className="d-flex" style={{ gap: 6, marginBottom: 12 }}>
        <Tab k="packages" tab={tab} setTab={setTab}>Paket şablonları</Tab>
        <Tab k="members" tab={tab} setTab={setTab}>Personel</Tab>
        <Tab k="grants" tab={tab} setTab={setTab}>Gönderimler</Tab>
      </div>

      {tab === "packages" && (
        <div className="row">
          {pk.packages.map((p) => (
            <div className="col-md-6 col-xl-4" key={p._id}>
              <div className="card">
                <div className="card-body">
                  <div className="d-flex justify-content-between align-items-center">
                    <b style={{ fontSize: 15 }}>{p.icon} {p.name}</b>
                    <Chip kind={p.isActive ? "ok" : "bad"}>{p.isActive ? "Aktif" : "Kapalı"}</Chip>
                  </div>
                  {p.note && <div style={{ fontSize: 12, color: "#64748B", marginTop: 4 }}>{p.note}</div>}
                  <ul style={{ margin: "10px 0", paddingLeft: 18, color: "#334155" }}>
                    {p.items.map((i, k) => (
                      <li key={k}>{i.name} · {i.days} gün</li>
                    ))}
                    {p.vipLevel > 0 && <li>VIP{p.vipLevel} · {p.vipDays} gün</li>}
                  </ul>
                  <button className="btn btn-sm btn-outline-primary" onClick={() => setPkg(JSON.parse(JSON.stringify(p)))}>Düzenle</button>
                </div>
              </div>
            </div>
          ))}
          {!pk.packages.length && <div className="badu-empty" style={{ padding: 20 }}>Henüz paket yok. “+ Paket” ile hoş geldin paketi oluştur.</div>}
        </div>
      )}

      {tab === "members" && (
        <div className="card">
          <div className="card-body table-responsive">
            <table className="table">
              <thead>
                <tr><th>Personel</th><th>Rol</th><th>Rütbe</th><th>Bölge</th><th>Bu ay gönderim</th><th>Durum</th><th /></tr>
              </thead>
              <tbody>
                {members.map((m) => (
                  <tr key={m._id}>
                    <td><b>{m.name}</b><div style={{ fontSize: 12, color: "#64748B" }}>{m.email}</div></td>
                    <td>{ROLE_LABEL[m.role]}</td>
                    <td>{m.role === "manager" ? RANK_LABEL[m.rank || "super"] : "—"}</td>
                    <td>{m.region || "—"}</td>
                    <td>
                      {(m.quotas || []).map((q) => {
                        const p = pk.packages.find((x) => x._id === q.templateId);
                        return p ? <div key={q.templateId} style={{ fontSize: 12 }}>{p.name}: {(m.used || {})[q.templateId] || 0}/{q.monthly}</div> : null;
                      })}
                    </td>
                    <td><Chip kind={m.isActive !== false ? "ok" : "bad"}>{m.isActive !== false ? "Aktif" : "Kapalı"}</Chip></td>
                    <td><button className="btn btn-sm btn-outline-primary" onClick={() => setEdit({ ...m, password: "" })}>Düzenle</button></td>
                  </tr>
                ))}
                {!members.length && <tr><td colSpan={7}><div className="badu-empty">Personel yok.</div></td></tr>}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {tab === "grants" && (
        <div className="card">
          <div className="card-body table-responsive">
            <table className="table">
              <thead><tr><th>Tarih</th><th>Personel</th><th>Paket</th><th>Alan kişi</th></tr></thead>
              <tbody>
                {grants.map((g) => (
                  <tr key={g._id}>
                    <td>{when(g.createdAt)}</td>
                    <td>{g.staffName} <span style={{ fontSize: 11, color: "#64748B" }}>{ROLE_LABEL[g.staffRole]}</span></td>
                    <td>{g.templateName}</td>
                    <td>{g.userName} · ID {g.uniqueID}</td>
                  </tr>
                ))}
                {!grants.length && <tr><td colSpan={4}><div className="badu-empty">Gönderim yok.</div></td></tr>}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {edit && (
        <div className="badu-modal" onClick={() => setEdit(null)}>
          <div className="card" style={{ maxWidth: 520, width: "100%" }} onClick={(e) => e.stopPropagation()}>
            <div className="card-body">
              <h5 style={{ marginBottom: 12 }}>{edit._id ? "Personeli düzenle" : "Yeni personel"}</h5>
              <div className="row">
                <div className="col-md-6 mb-2"><label className="small">Ad</label><input className="form-control" value={edit.name} onChange={(e) => setEdit({ ...edit, name: e.target.value })} /></div>
                <div className="col-md-6 mb-2"><label className="small">E-posta</label><input className="form-control" value={edit.email} onChange={(e) => setEdit({ ...edit, email: e.target.value })} /></div>
                <div className="col-md-6 mb-2"><label className="small">{edit._id ? "Yeni şifre (boş = değişmez)" : "Şifre (en az 8)"}</label><input className="form-control" type="password" autoComplete="new-password" value={edit.password} onChange={(e) => setEdit({ ...edit, password: e.target.value })} /></div>
                <div className="col-md-6 mb-2"><label className="small">Rol</label>
                  <select className="form-control" value={edit.role} onChange={(e) => setEdit({ ...edit, role: e.target.value })}>
                    {ROLES.map((r) => <option key={r} value={r}>{ROLE_LABEL[r]}</option>)}
                  </select>
                </div>
                {edit.role === "manager" && (
                  <div className="col-md-6 mb-2">
                    <label className="small">Rütbe (aylık geçerli ajans hedefi)</label>
                    <select className="form-control" value={edit.rank || "super"} onChange={(e) => setEdit({ ...edit, rank: e.target.value })}>
                      {RANKS.map(([k, v]) => <option key={k} value={k}>{v}</option>)}
                    </select>
                  </div>
                )}
                <div className="col-md-6 mb-2"><label className="small">Bölge</label><input className="form-control" placeholder="Körfez, Türkiye…" value={edit.region} onChange={(e) => setEdit({ ...edit, region: e.target.value })} /></div>
                <div className="col-md-6 mb-2 d-flex align-items-end"><label className="small d-flex" style={{ gap: 6 }}><input type="checkbox" checked={edit.isActive !== false} onChange={(e) => setEdit({ ...edit, isActive: e.target.checked })} /> Hesap aktif</label></div>
              </div>
              {["manager", "agency_rep", "moderator", "finance"].includes(edit.role) && (
                <>
                  <div style={{ fontWeight: 600, margin: "10px 0 6px" }}>Aylık paket kotası</div>
                  {pk.packages.map((p) => {
                    const q = (edit.quotas || []).find((x) => x.templateId === p._id);
                    return (
                      <div key={p._id} className="d-flex justify-content-between align-items-center" style={{ padding: "4px 0" }}>
                        <span>{p.icon} {p.name}</span>
                        <input className="form-control form-control-sm" style={{ width: 80 }} type="number" min="0" value={q?.monthly || 0}
                          onChange={(e) => {
                            const rest = (edit.quotas || []).filter((x) => x.templateId !== p._id);
                            setEdit({ ...edit, quotas: [...rest, { templateId: p._id, monthly: Number(e.target.value) || 0 }] });
                          }} />
                      </div>
                    );
                  })}
                </>
              )}
              <div className="d-flex justify-content-end" style={{ gap: 8, marginTop: 14 }}>
                <button className="btn btn-outline-secondary" onClick={() => setEdit(null)}>Vazgeç</button>
                <button className="btn btn-primary" onClick={saveMember}>Kaydet</button>
              </div>
            </div>
          </div>
        </div>
      )}

      {pkg && (
        <div className="badu-modal" onClick={() => setPkg(null)}>
          <div className="card" style={{ maxWidth: 560, width: "100%" }} onClick={(e) => e.stopPropagation()}>
            <div className="card-body">
              <h5 style={{ marginBottom: 12 }}>{pkg._id ? "Paketi düzenle" : "Yeni paket"}</h5>
              <div className="row">
                <div className="col-3 mb-2"><label className="small">İkon</label><input className="form-control" value={pkg.icon} onChange={(e) => setPkg({ ...pkg, icon: e.target.value })} /></div>
                <div className="col-9 mb-2"><label className="small">Paket adı</label><input className="form-control" placeholder="Yeni Ajans Paketi" value={pkg.name} onChange={(e) => setPkg({ ...pkg, name: e.target.value })} /></div>
                {[["tr", "Türkçe ad"], ["en", "English name"], ["ar", "Arapça ad"]].map(([k, l]) => (
                  <div key={k} className="col-4 mb-2"><label className="small">{l}</label><input className="form-control" dir={k === "ar" ? "rtl" : "ltr"} value={(pkg.names || {})[k] || ""} onChange={(e) => setPkg({ ...pkg, names: { ...(pkg.names || {}), [k]: e.target.value } })} /></div>
                ))}
                <div className="col-12 mb-2"><label className="small">Not (personel görür)</label><input className="form-control" value={pkg.note} onChange={(e) => setPkg({ ...pkg, note: e.target.value })} /></div>
              </div>
              <div style={{ fontWeight: 600, margin: "8px 0 6px" }}>Mağaza öğeleri</div>
              {(pk.storeItems || []).map((s) => {
                const on = pkg.items.find((i) => String(i.itemId) === s._id);
                return (
                  <div key={s._id} className="d-flex align-items-center" style={{ gap: 8, padding: "3px 0" }}>
                    <input type="checkbox" checked={!!on} onChange={(e) => setPkg({ ...pkg, items: e.target.checked ? [...pkg.items, { itemId: s._id, days: 7 }] : pkg.items.filter((i) => String(i.itemId) !== s._id) })} />
                    {/* donma onlemi: agir animasyonlu giris efektlerinin resmi yuklenmez; digerleri gorunurken ve tembel yuklenir */}
                    {s.image && s.type !== "entry" && !/\.svga$/i.test(s.image) ? <img src={img(s.image)} alt="" loading="lazy" decoding="async" style={{ width: 26, height: 26, objectFit: "contain" }} /> : <span style={{ width: 26, textAlign: "center" }}>{s.type === "entry" ? "✨" : ""}</span>}
                    <span style={{ flex: 1 }}>{s.name} <span style={{ fontSize: 11, color: "#64748B" }}>{s.type === "frame" ? "çerçeve" : "giriş efekti"}</span></span>
                    {on && <input className="form-control form-control-sm" style={{ width: 70 }} type="number" min="1" value={on.days} onChange={(e) => setPkg({ ...pkg, items: pkg.items.map((i) => (String(i.itemId) === s._id ? { ...i, days: Number(e.target.value) || 1 } : i)) })} />}
                    {on && <span className="small">gün</span>}
                  </div>
                );
              })}
              <div className="row" style={{ marginTop: 10 }}>
                <div className="col-6"><label className="small">VIP seviyesi (0 = yok)</label><input className="form-control" type="number" min="0" max="6" value={pkg.vipLevel} onChange={(e) => setPkg({ ...pkg, vipLevel: Number(e.target.value) || 0 })} /></div>
                <div className="col-6"><label className="small">VIP gün</label><input className="form-control" type="number" min="0" max="90" value={pkg.vipDays} onChange={(e) => setPkg({ ...pkg, vipDays: Number(e.target.value) || 0 })} /></div>
              </div>
              <label className="small d-flex" style={{ gap: 6, marginTop: 10 }}><input type="checkbox" checked={pkg.isActive !== false} onChange={(e) => setPkg({ ...pkg, isActive: e.target.checked })} /> Paket aktif</label>
              <div className="d-flex justify-content-end" style={{ gap: 8, marginTop: 14 }}>
                <button className="btn btn-outline-secondary" onClick={() => setPkg(null)}>Vazgeç</button>
                <button className="btn btn-primary" onClick={savePkg}>Kaydet</button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Staff;
